import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

const QVTrigger = ({styles}) => {
    return (
        <Box
            data-qv-trigger
            width="24px"
            height="24px"
            backgroundColor="#FFFFFF"
            backdropFilter="blur(10px)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            {...styles}
            sx={{
                '& svg': {
                    transition: 'transform 200ms ease'
                }
            }}
        >
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.33333 0.5V12.1667M0.5 6.33333H12.1667"
                    stroke="black"
                    strokeLinecap="square"
                />
            </svg>
        </Box>
    )
}

export default QVTrigger
